import PropTypes from 'prop-types';
import { getConfig } from '../config.js';
import getClientSlug from '../helpers/clientSlug.js';

export default async function apiServicewt(quary) {
	const webLink = getConfig().REACT_APP_WEB_LINK;
	const slug = getClientSlug();
	const payload = slug ? { ...quary, slug: slug } : quary;
	const result = await fetch(webLink, {
		method: 'post',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		body: JSON.stringify(payload),
	});
	const responce = await result.json();
	if (responce.type === 'error') {
	}
	return responce;
}

apiServicewt.propTypes = {
	quary: PropTypes.isRequired,
	navigator: PropTypes.isRequired,
};
